import React from 'react';

interface SelectionCheckboxProps {
  checked: boolean;
  indeterminate?: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  'aria-label'?: string;
  className?: string;
}

export const SelectionCheckbox: React.FC<SelectionCheckboxProps> = ({
  checked,
  indeterminate = false,
  onChange,
  disabled = false,
  'aria-label': ariaLabel,
  className = ''
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  const inputRef = React.useRef<HTMLInputElement>(null);

  // Set indeterminate property on the actual DOM element
  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <input
      ref={inputRef}
      type="checkbox"
      checked={checked}
      onChange={handleChange}
      disabled={disabled}
      aria-label={ariaLabel}
      className={`w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 ${className}`}
    />
  );
};